import { FiltersConfig } from '../types'

export const buildFiltersOptions = (filtersConfig: FiltersConfig | undefined): FiltersConfig => {
  return {
    header: false,
    ...filtersConfig
  }
}
